export default (action) => (agreement) => {
  const { code } = action.payload.agreement;

  return code === agreement.code ? ({
    ...agreement,
    checked: !agreement.checked
  }) : agreement;
};
